import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { useTrialsContext } from 'contexts/TrialsContextProvider';

import {
  BUSINESS_INFO_MODAL_ROUTE,
  BUY_NOW_MODAL_ROUTE,
  EXISTING_USER_INVITATION,
  PROFILE_MODAL_ROUTE,
  VERIFY_ACCOUNT_MODAL_ROUTE,
} from '../constants';

import AccountVerification from './AccountVerification';
import BusinessInfo from './BusinessInfo';
import CreateAccount from './CreateAccount';
import ExistingUserInvite from './ExistingUserInvite';
import FakeCreatingAccountLoading from './FakeCreateAccountLoading';
import Intent from './Intent';
import Profile from './Profile';
import BuyNowWithDiscountAndCheckout from './BuyNowWithDiscount';
import TrialSubmitLoadingState from './LoadingState/TrialSubmitLoadingState';
import RoiSignupPage from './RoiSignupPage';

// react-router v6 upgrade, no need to add the parent path "/trials"
export const TrialModalView = () => {
  const { isRoiSignupPage } = useTrialsContext() || {};

  return (
    <Routes>
      <Route element={<Profile />} path={PROFILE_MODAL_ROUTE} />
      <Route
        element={<AccountVerification />}
        path={VERIFY_ACCOUNT_MODAL_ROUTE}
      />
      <Route
        element={<BuyNowWithDiscountAndCheckout />}
        path={`${BUY_NOW_MODAL_ROUTE}/*`}
      />
      <Route element={<BusinessInfo />} path={BUSINESS_INFO_MODAL_ROUTE} />
      <Route element={<ExistingUserInvite />} path={EXISTING_USER_INVITATION} />
      <Route element={<FakeCreatingAccountLoading />} path="creating-account" />
      <Route element={<Intent />} path="intent" />
      <Route element={<TrialSubmitLoadingState />} path="loading" />
      <Route
        element={isRoiSignupPage ? <RoiSignupPage /> : <CreateAccount />}
        path="*"
      />
    </Routes>
  );
};

export default TrialModalView;
